import React from 'react';
import { Box, Stack, Typography, Avatar } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { portal, portalGradientTextSx } from '../styles/dashboardBrand';

/**
 * Consistent hero-style title row for user dashboard pages (matches Activity look).
 */
export default function DashboardPageHeader({ icon: Icon, title, subtitle, children, titleTrail, sx: sxProp }) {
  return (
    <Stack
      spacing={1.5}
      sx={(theme) => ({
        mb: { xs: 2, sm: 3 },
        ...(typeof sxProp === 'function' ? sxProp(theme) : sxProp || {}),
      })}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={1.25}
        flexWrap="nowrap"
        useFlexGap
        sx={{ width: '100%' }}
      >
        {Icon ? (
          <Avatar
            sx={{
              width: 48,
              height: 48,
              flexShrink: 0,
              background: portal.gradientHero,
              boxShadow: `0 8px 32px ${alpha(portal.cyan, 0.35)}`,
            }}
          >
            <Icon sx={{ fontSize: 26 }} />
          </Avatar>
        ) : null}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Stack
            direction="row"
            alignItems="flex-start"
            flexWrap="wrap"
            useFlexGap
            spacing={1.5}
            sx={{ rowGap: 0.75, width: '100%' }}
          >
            <Typography
              variant="h4"
              component="h1"
              sx={portalGradientTextSx({
                fontWeight: 800,
                letterSpacing: '-0.02em',
                lineHeight: 1.2,
                fontSize: { xs: '1.5rem', sm: '1.85rem', md: '2rem' },
                m: 0,
                flexShrink: 0,
              })}
            >
              {title}
            </Typography>
            {titleTrail ? (
              <Box
                sx={{
                  minWidth: 0,
                  ml: 'auto',
                  alignSelf: 'flex-start',
                  pt: 0,
                  mt: 0,
                }}
              >
                {titleTrail}
              </Box>
            ) : null}
          </Stack>
          {subtitle ? (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mt: 0.25, maxWidth: 680, lineHeight: 1.6 }}
            >
              {subtitle}
            </Typography>
          ) : null}
        </Box>
        {children ? (
          <Box
            sx={{
              width: { xs: '100%', sm: 'auto' },
              ml: { xs: 0, sm: 'auto' },
              display: 'flex',
              alignItems: 'center',
              justifyContent: { xs: 'flex-start', sm: 'flex-end' },
              flexWrap: 'wrap',
              gap: 1,
            }}
          >
            {children}
          </Box>
        ) : null}
      </Stack>
    </Stack>
  );
}
